import { Button } from '@shared/components/ui/button';
import { Loader2 } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useVerifyNewEmail } from '../hooks/useVerifyNewEmail';

const VerifyNewEmailPage: React.FC = () => {
  const { t } = useTranslation('usersModule');
  const [searchParams] = useSearchParams();
  const verifyMutation = useVerifyNewEmail();

  const token = searchParams.get('token');

  const handleVerify = async () => {
    if (!token) {
      console.warn('[VerifyNewEmailPage] No token in URL');
      return;
    }

    try {
      await verifyMutation.mutateAsync(token);
    } catch (e) {
      console.error('[VerifyNewEmailPage] Exception during mutate:', e);
    }
  };

  if (!token) {
    return (
      <div className="mx-auto">
        <div className="flex w-full justify-center md:items-center pt-16">
          <div className="w-96 p-8">
            <h2 className="text-2xl font-bold py-2 text-card-title">
              {t('verifyNewEmail.errors.tokenRequired', 'Token no encontrado')}
            </h2>
            <div className="mt-4 p-4 bg-destructive/10 border border-destructive rounded-md">
              <p className="text-sm text-destructive">
                {t('verifyNewEmail.errors.tokenRequired', 'Token no encontrado en la URL')}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto">
      <div className="flex w-full justify-center md:items-center pt-16">
        <div className="w-96 p-8">
          <h2 className="text-2xl md:text-[28px] font-bold py-2 text-card-title">
            {t('verifyNewEmail.title', 'Verificar Nuevo Email')}
          </h2>
          <p className="text-sm leading-relaxed pb-4">
            {t(
              'verifyNewEmail.description',
              'Has recibido un enlace para verificar tu nuevo correo electrónico. Haz clic en el botón para confirmar el cambio.',
            )}
          </p>

          <div className="pt-4">
            <Button
              onClick={handleVerify}
              disabled={verifyMutation.isPending}
              className="w-full"
              data-testid="verify-new-email-submit"
            >
              {verifyMutation.isPending ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  {t('verifyNewEmail.buttons.verifying', 'Verificando...')}
                </>
              ) : (
                t('verifyNewEmail.button', 'Verificar nuevo email')
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyNewEmailPage;
